export enum ForStatusesEnum {
  PRE_FLIGHT = "PRE_FLIGHT",
  CANCELLED = "CANCELLED",
  IN_PROGRESS = "IN_PROGRESS",
  SIGNED = "SIGNED",
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  INCOMPLETE = "INCOMPLETE",
}

export interface CancellationReason {
  readonly cancellationReason?: string;
  readonly forStatuses?: ReadonlyArray<ForStatusesEnum>;
  readonly id?: string;
}
